import axios from 'axios';
import BaseAPI from './base/base-api';

class InvoiceAPI extends BaseAPI {
	constructor() {
		super();
		try {
			window._axiosVersion = axios.VERSION;
		}
		catch (error) 
		{
			
		}
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'invoices';
}

export default new InvoiceAPI();
